let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("fliVL"), load("7Me5p")]).then(() => parcelRequire('97MV1'));